import { render, staticRenderFns } from "./pinganWhiteList.vue?vue&type=template&id=78f2f2ba&scoped=true&"
import script from "./pinganWhiteList.vue?vue&type=script&lang=js&"
export * from "./pinganWhiteList.vue?vue&type=script&lang=js&"
import style0 from "./pinganWhiteList.vue?vue&type=style&index=0&id=78f2f2ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f2f2ba",
  null
  
)

export default component.exports